import * as yup from 'yup'

let newsletterSchema = yup.object().shape({
  email: yup
    .string()
    .email('*Email must be a valid email')
    .required('*Required'),
  policy: yup.boolean().oneOf([true]).required('*Required')
})

export default newsletterSchema
